import React, { useEffect, useRef, useState } from "react";
import styles from "./Login.module.scss";
import Button from "components/Button/Button";
import LoginLayout from "./LoginLayout";
import SignIn from "./SignIn/SignIn";
import LostPassword from "./LostPassword/LostPassword";
import logos from "assets/images/canaleducacao/Logotipos-Canal-Acerela-Seduc.png";
import { Link, useLocation, useParams } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { Tooltip } from "react-tooltip";
import { FcGoogle } from "react-icons/fc";
import { loginWithGoogle, handleAuthRedirect } from "services";
import GoogleCpfModal from "components/GoogleCpfModal/GoogleCpfModal";
import AccessInfoModal from "components/AccessInfoModal/AccessInfoModal";
import toast from "react-hot-toast";

function Login() {
  const { link, connection } = useParams();
  const location = useLocation();
  const [googleCredential, setGoogleCredential] = useState(null);
  const [showCpfModal, setShowCpfModal] = useState(false);
  const [showAccessInfoModal, setShowAccessInfoModal] = useState(
    !location.state?.skipAccessInfoModal,
  );
  const googleButtonWrapperRef = useRef(null);
  const [googleButtonWidth, setGoogleButtonWidth] = useState(280);

  useEffect(() => {
    if (!googleButtonWrapperRef.current) return;

    const observer = new ResizeObserver(([entry]) => {
      setGoogleButtonWidth(Math.round(entry.contentRect.width));
    });
    observer.observe(googleButtonWrapperRef.current);
    return () => observer.disconnect();
  }, []);

  const handleGoogleSuccess = async (credentialResponse) => {
    const { credential } = credentialResponse;
    const toastId = toast.loading("Autenticando com Google...");
    const response = await loginWithGoogle(credential);
    toast.dismiss(toastId);

    if (response?.status === 200) {
      handleAuthRedirect(response.data);
      return;
    }

    if (response?.status === 404) {
      setGoogleCredential(credential);
      setShowCpfModal(true);
      return;
    }

    toast.error(
      response?.data?.error ||
        "Conta não encontrada. Verifique se você está usando o email correto.",
    );
  };

  return (
    <LoginLayout>
      <div className={styles.body}>
        <div className={styles.btnGroup}>
          <Button
            modifiers={["outline", "full"]}
            anchor
            to={
              link && connection ? `/entrar/${link}/${connection}` : "/entrar"
            }
          >
            Entrar com e-mail
          </Button>

          <div
            className={styles.googleButtonWrapper}
            ref={googleButtonWrapperRef}
            data-tooltip-id="google-button-tooltip"
          >
            <div className={styles.googleButtonVisual}>
              <Button
                modifiers={["outline", "full"]}
                type="button"
                tabIndex={-1}
              >
                <FcGoogle size={20} />
                Entrar com e-mail SEDUC.PI
              </Button>
            </div>

            <div className={styles.googleButtonOverlay}>
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={() => toast.error("Erro ao autenticar com Google")}
                locale="pt-BR"
                shape="pill"
                width={googleButtonWidth}
              />
            </div>
          </div>

          <Tooltip
            id="google-button-tooltip"
            place="top-end"
            offset={-8}
            noArrow
            opacity={1}
            style={{
              maxWidth: "230px",
              fontSize: "1.2rem",
              background: "#f1f5fa",
              color: "#5D6A86",
              padding: "8px",
            }}
            border="1px solid #ECE9F8"
          >
            O seu e-mail SEDUC.PI é parecido com “seunome@aluno.edu.pi.gov.br”
            ou “seunome@professor.edu.pi.gov.br
          </Tooltip>
          <p className={styles.helperText}>
            Não sabe seu e-mail institucional?{" "}
            <Link
              to="/consultar-email/informar-cpf"
              className={styles.helperLink}
            >
              Clique aqui
            </Link>
          </p>
        </div>
      </div>

      <div className={styles.footer}>
        {/* <Button
          modifiers={["review", "full"]}
          anchor
          to={
            link && connection
              ? `/criar-uma-conta/${link}/${connection}/consulta-de-dados`
              : "/criar-uma-conta/consulta-de-dados"
          }
        >
          Criar uma conta nova
        </Button>

        <br />
        {/* RETORNAR APÓS PERÍODO ELEITORAL */}
        {/* <img src={logos} alt="Logos" /> */}
      </div>

      <GoogleCpfModal
        isOpen={showCpfModal}
        onClose={() => setShowCpfModal(false)}
        googleCredential={googleCredential}
      />

      <AccessInfoModal
        isOpen={showAccessInfoModal}
        onClose={() => setShowAccessInfoModal(false)}
      />
    </LoginLayout>
  );
}

export { Login as default, SignIn, LostPassword, LoginLayout };
